import React from 'react';
import Loading from '../components/Loading';
import NotFound from '../components/NotFound';
import { getProject } from '../services/BaseService';
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";

export default function CanAccess({
  form = {},
  data = {},
  content
}) {
  return Object.keys(form).length === 0 ?
    <Loading /> : (
      Object.keys(form).length > 0 && Object.keys(data).length === 0 ?
        <NotFound /> :
        content
    );
}
export const defaultProjects = ['myOwnData', 'all'];
export const PROJECTS = {
  all: 'all',
  myData: 'myOwnData'
};

export const isSelectedProject = (user, redirect = false) => {
  const selectedProject = getProject();
  if (defaultProjects.includes(selectedProject) && (!user || !user.projects || !Array.isArray(user.projects))) {
    StorageManager.clearOne('project');
    if (redirect) {
      window.location = '/app/pme/projects';
    }
    return false;
  }
  return true;
}